import { IContentSetVersionEnquirySummary } from "@/models/interfaces/enquiry/content-set-version-enquiry-summary.model.interface";
import { ICreativeEnquirySummary } from "@/models/interfaces/enquiry/creative-enquiry-summary.model.interface";

export class ContentSetVersionEnquirySummary implements IContentSetVersionEnquirySummary {
    public contentSetVersionId: number = 0;
    public templates: ICreativeEnquirySummary[];

    constructor(contentSetVersionId: number = 0) {
        this.contentSetVersionId = contentSetVersionId;
        this.templates = [];
    }
}
